import React from "react";

const handleLogin = (props) => {
    const user = {
        username: document.getElementById("username").value,
        password: document.getElementById("password").value
    }
    console.log(process.env.REACT_APP_SERVER_URL);
    const url = process.env.REACT_APP_SERVER_URL + "/login";
    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json", // Specify the content type
        },
        body: JSON.stringify(user), // Convert data to JSON string
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json(); // Parse the JSON response
        })
        .then((result) => {
            localStorage.setItem("Authorization", `Bearer ${result.token}`);
            props.setLoggedIn(true);

        })
        .catch((error) => {
            alert("Wrong Credentials")
        });

}
const Login = (props) => {

    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center">
            <div className="bg-white p-8  shadow-md w-full max-w-md">
                <h2 className="text-2xl font-bold text-center text-gray-800 mb-4">
                    Login to Your Account
                </h2>
                <div className="mb-4">
                    <label
                        htmlFor="username"
                        className="block text-gray-700 font-medium mb-2"
                    >
                        User Name
                    </label>
                    <input
                        type="username"
                        id="username"
                        className="w-full px-4 py-2 border border-gray-300  focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Enter your user name"
                    />
                </div>
                <div className="mb-4">
                    <label
                        htmlFor="password"
                        className="block text-gray-700 font-medium mb-2"
                    >
                        Password
                    </label>
                    <input
                        type="password"
                        id="password"
                        className="w-full px-4 py-2 border border-gray-300  focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Enter your password"
                    />
                </div>
                <button
                    onClick={()=>{handleLogin(props)}}
                    className="w-full bg-purple-950 text-white py-2  hover:bg-fuchsia-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                    Login
                </button>
            </div>
        </div>
    );
};

export default Login;
